import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home.component';

const routes: Routes = [ 
 // { path: '', component: HomeComponent, pathMatch:'full' }
 // { path: 'home', component: HomeComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }




// WEBPACK FOOTER //
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/app/home/home-routing.module.ts